import { Reveal, ChapterLabel } from "@/components/Reveal";
import { useLang } from "@/i18n";
import { IMAGES } from "@/content/images";

const Intro = () => {
  const { t } = useLang();
  const d = t.intro;

  return (
    <section data-testid="intro-section" className="bg-ivory px-6 md:px-12 py-28 md:py-44">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-16 md:grid-cols-12 md:gap-8">
        <div className="md:col-span-7 md:col-start-1">
          <ChapterLabel index={d.chapter} title={d.label} />
          <Reveal delay={0.1}>
            <h2 data-testid="intro-headline"
              className="mt-10 font-display text-charcoal text-4xl sm:text-5xl lg:text-[4.2rem] leading-[1.05] tracking-tight">
              {d.headingA}
              <br />
              <span className="italic font-light text-espresso/90">{d.headingB}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-12 max-w-xl text-lg md:text-xl leading-relaxed text-charcoal/80">{d.lead}</p>
          </Reveal>
          <Reveal delay={0.24}>
            <p className="mt-10 font-display italic font-light text-2xl md:text-3xl text-espresso">{d.closing}</p>
          </Reveal>
        </div>

        <div className="md:col-span-4 md:col-start-9 md:mt-24">
          <Reveal delay={0.15} y={40}>
            <div className="img-frame aspect-[3/4]">
              <img src={IMAGES.intro} alt="Cabo Yoga & Fitness studio in Plaza Nova, Cabo San Lucas"
                data-testid="intro-image" loading="lazy" className="h-full w-full object-cover object-center" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Intro;
